import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next'; 
import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

const renderOption = (option, onChange, t) => (
  <Dropdown.Item
    as="a"
    key={option}
    onClick={onChange}
    data-code={option}
    className="tournaments__dropdown-filter__option"
  >
    <p>{t(`tournaments.${option}`)}</p>
  </Dropdown.Item>
);

const TournamentDropdownFilter = ({ options, selected, onChange, neutral, removeSelectedOption}) => {
  const {t} = useTranslation();
  const onClick = useCallback(e => onChange(e.currentTarget.dataset.code), [onChange]);

  return (
    <Dropdown className="tournaments__dropdown-filter">
      <Dropdown.Toggle className="tournaments__dropdown-filter__button">
        <p>{t([`tournaments.${selected}`, selected])}</p>
        <FontAwesomeIcon className="fa fa-angle-down" icon={faAngleDown} />
      </Dropdown.Toggle>
      <Dropdown.Menu className="tournaments__dropdown-filter__menu">
        {removeSelectedOption 
          ? [...options, neutral].filter(option => option !== selected).map(o => renderOption(o, onClick, t)) 
          : [...options, neutral].map(o => renderOption(o, onClick, t))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default TournamentDropdownFilter;